<template>
	<div class="container solarContainer">
			<div class="colIcon">
				<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In  -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.91px"
					 height="48.49px" viewBox="0 0 40.91 48.49" style="enable-background:new 0 0 40.91 48.49;" xml:space="preserve">
					<defs>
</defs>
					<path class="st0" d="M39.75,7.85L21.18,0.14c-0.47-0.19-0.99-0.19-1.45,0L1.17,7.85C0.46,8.15,0,8.84,0,9.6v9.37
c0,12.9,7.8,24.5,19.74,29.38c0.46,0.19,0.97,0.19,1.43,0c11.94-4.87,19.74-16.48,19.74-29.38V9.6C40.91,8.84,40.45,8.15,39.75,7.85
z"/>
					<path class="st1" d="M37.12,18.97c0,10.97-6.44,21.06-16.67,25.57C10.5,40.15,3.79,30.23,3.79,18.97v-8.1l16.67-6.92l16.67,6.92
V18.97z"/>
					<path class="st2" d="M18.36,25.35l8.14-8.14c0.74-0.74,1.94-0.74,2.68,0c0.74,0.74,0.74,1.94,0,2.68l-9.48,9.48
c-0.74,0.74-1.94,0.74-2.68,0l-5.29-5.29c-0.74-0.74-0.74-1.94,0-2.68c0.74-0.74,1.94-0.74,2.68,0L18.36,25.35z"/>
</svg>

				<p>Надежный источник электроэнергии</p>
			</div>
			<div class="colIcon">
				<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In  -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.17px"
					 height="46.75px" viewBox="0 0 44.17 46.75" style="enable-background:new 0 0 44.17 46.75;" xml:space="preserve">
					<defs>
</defs>
					<path class="st0" d="M9.89,12.23c0,0,1.14,1.75,2.29,3.21c6.22,7.85,13.95,13.12,22.21,15.14c0.71,0.17,2.11,0.44,3.16,0.61
l0.55,0.09l0.03,1.07c0.02,0.59,0.04,1.12,0.05,1.18c0.01,0.1,0.17,0.03,2.06-0.96c2.08-1.1,3.39-1.81,3.64-1.98
c0.07-0.05,0.12-0.12,0.11-0.14c-0.05-0.07-1.28-0.98-3.57-2.61l-2.22-1.59l-0.01,0.16c0,0.09-0.03,0.73-0.05,1.43
c-0.03,1.12-0.05,1.27-0.13,1.36c-0.13,0.15-0.41,0.13-1.51-0.07c-4.48-0.84-8.53-2.52-12.56-5.2c-2.43-1.62-4.23-3.1-6.47-5.35
c-2.14-2.14-3.51-3.78-5.6-6.69c-0.27-0.37-0.5-0.68-0.52-0.68C11.33,11.22,9.89,12.23,9.89,12.23z"/>
					<path class="st2" d="M2.14,30.63v16.12h3.27h3.27V30.63V14.52H5.42H2.14V30.63z"/>
					<path class="st2" d="M11.04,36.23v10.52h3.27h3.27l-0.01-10.51l-0.01-10.51l-3.26-0.01l-3.26-0.01V36.23z"/>
					<path class="st2" d="M19.92,30.89c-0.02,0.01-0.03,3.59-0.03,7.95v7.91h3.27h3.27V38.8v-7.95h-3.24
C21.41,30.86,19.94,30.87,19.92,30.89z"/>
					<path class="st2" d="M28.78,40.68v6.07h3.27h3.27v-6.07v-6.07h-3.27h-3.27V40.68z"/>
					<path class="st2" d="M37.63,41.85v4.9h3.27h3.27v-4.9v-4.9H40.9h-3.27V41.85z"/>
					<path class="st2" d="M6.31,3.73H5.13v1.42h1.18c0.39,0,0.71-0.32,0.71-0.71S6.7,3.73,6.31,3.73z"/>
					<path class="st2" d="M9.57,1.64c-2.19-2.19-5.74-2.19-7.93,0c-2.19,2.19-2.19,5.74,0,7.93c2.19,2.19,5.74,2.19,7.93,0
C11.77,7.38,11.77,3.84,9.57,1.64z M6.31,6.07H5.13v0.48h0.94c0.25,0,0.46,0.21,0.46,0.46c0,0.25-0.21,0.46-0.46,0.46H5.13v0.48
c0,0.25-0.21,0.46-0.46,0.46c-0.25,0-0.46-0.21-0.46-0.46V7.47H3.74c-0.25,0-0.46-0.21-0.46-0.46c0-0.25,0.21-0.46,0.46-0.46h0.48
V6.07H3.74c-0.25,0-0.46-0.21-0.46-0.46c0-0.25,0.21-0.46,0.46-0.46h0.48V3.27c0-0.25,0.21-0.46,0.46-0.46h1.64
c0.9,0,1.63,0.73,1.63,1.63C7.94,5.34,7.21,6.07,6.31,6.07z"/>
</svg>

				<p>Снижение затрат на дорогостоящее топливо</p>
			</div>
			<div class="colIcon">
				<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In  -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="42.29px"
					 height="42.67px" viewBox="0 0 42.29 42.67" style="enable-background:new 0 0 42.29 42.67;" xml:space="preserve">

					<defs>
</defs>
					<polygon class="st2" points="28.34,18.76 21.23,18.76 24.78,9.06 13.95,23.91 21.06,23.91 17.51,33.6 "/>
					<path class="st0" d="M41.39,15.17l-2.54,0.77c0.53,1.75,0.79,3.55,0.79,5.37c0,10.25-8.34,18.58-18.58,18.58
c-3.67,0-7.33-1.07-10.3-3.01l3.19-3.66l-10.21-0.9l1.9,10.35l3.4-3.88c3.48,2.41,7.63,3.76,12.02,3.76
c11.71,0,21.24-9.53,21.24-21.24C42.29,19.23,41.99,17.16,41.39,15.17L41.39,15.17z"/>
					<path class="st0" d="M0.91,27.5l2.54-0.77c-0.53-1.75-0.79-3.55-0.79-5.37c0-10.25,8.34-18.58,18.58-18.58
c3.67,0,7.33,1.07,10.3,3.01l-3.19,3.66l10.21,0.9L36.66,0l-3.4,3.88c-3.48-2.41-7.63-3.76-12.02-3.76C9.53,0.12,0,9.65,0,21.36
C0,23.44,0.31,25.5,0.91,27.5L0.91,27.5z"/>
</svg>

				<p>Отсутствие перебоев и скачков напряжения</p>
			</div>
			<div class="colIcon">
				<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In  -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="47.19px"
					 height="41.74px" viewBox="0 0 47.19 41.74" style="enable-background:new 0 0 47.19 41.74;" xml:space="preserve">
					<defs>
</defs>
					<path class="st2" d="M10.24,13.2l-2.07-0.63c0.68-0.73,1.42-1.45,2.21-2.15l7.55,1.39L11.4,9.55c0.92-0.74,1.9-1.44,2.94-2.06
l7.42,1.86L15.6,6.77c2.7-1.41,5.78-2.34,9.23-2.37c-0.22,1.55-0.98,5.36-3.2,8.45h1.85c2.56-4,2.95-8.66,2.97-8.95
c0-0.01-0.01-0.03-0.01-0.04c0.1-0.27-0.05-0.59-0.4-0.75C14.17-2.34,7.95,0.57,5.29,2.79C1.22,6.2,0.52,11.9,2.62,14.54
c0.05,0.06,0.12,0.12,0.19,0.17c0.26,0.17,0.61,0.21,0.88,0.08c0.35-0.16,0.44-0.53,0.21-0.83C2.33,12,2.72,6.82,6.47,3.69
c2.68-2.25,7.73-4.02,16.78-0.44c-3.1,0.22-5.88,1.08-8.36,2.33l0.12-3.1l-1.69,3.96c-1.1,0.66-2.12,1.38-3.08,2.15L9.76,3.49
L8.81,9.64c-0.01,0.04-0.01,0.08,0,0.12c0,0.02,0.01,0.03,0.02,0.04c-0.6,0.55-1.18,1.11-1.72,1.68l-0.98-3.8l-0.17,5.06
c-3.79,4.38-5.75,8.68-5.92,9.05c-0.11,0.25,0.01,0.54,0.28,0.71c0.06,0.04,0.13,0.07,0.2,0.1c0.41,0.14,0.84,0.01,0.98-0.3
c0.04-0.09,2.02-4.43,5.84-8.82l2.27,0.26v-0.42L10.24,13.2z"/>
					<path class="st2" d="M6.73,16.17c-0.4-0.14-0.84,0-0.98,0.3c-0.13,0.31,0.08,0.67,0.49,0.81c1.17,0.4,2.29,0.71,3.37,0.93v-1.24
C8.69,16.78,7.73,16.52,6.73,16.17z"/>
					<path class="st2" d="M33.09,12.75c0.25-0.35,0.25-0.8-0.01-1.02c-0.26-0.22-0.67-0.12-0.92,0.23c-0.26,0.35-0.49,0.7-0.72,1.05
c0.4,0.13,0.78,0.29,1.14,0.48C32.75,13.25,32.91,13,33.09,12.75z"/>
					<path class="st0" d="M35.85,9.3c-0.08,0.03-0.15,0.08-0.22,0.13c-0.23,0.2-0.38,0.52-0.34,0.82c0.05,0.38,0.38,0.58,0.73,0.44
c2.33-0.93,7.18,0.95,9.09,5.44c1.37,3.22,1.6,8.57-4.46,16.18c0.69-3.03,0.68-5.94,0.2-8.67l2.93,1.02l-3.3-2.77
c-0.31-1.24-0.7-2.43-1.16-3.57l5.01,1.02l-5.61-2.69c-0.03-0.02-0.07-0.03-0.11-0.04c-0.02,0-0.03,0-0.05,0
c-0.35-0.74-0.72-1.45-1.1-2.13l3.93,0.17l-4.79-1.63c-3.08-4.9-6.63-8.03-6.94-8.3c-0.21-0.18-0.52-0.15-0.76,0.06
c-0.06,0.05-0.11,0.1-0.15,0.17c-0.25,0.34-0.25,0.8,0,1.02c0.07,0.06,3.65,3.22,6.73,8.16l-0.61,1.41
c0.18,0.25,0.34,0.51,0.48,0.79l0.77-1.15c0.5,0.87,0.97,1.78,1.41,2.74l-1.27,2.45c0,0.49-0.04,0.96-0.11,1.41l1.9-2.62
c0.44,1.09,0.82,2.23,1.12,3.41l-3.94,6.56l4.26-5.15c0.57,3,0.56,6.21-0.42,9.52c-1.46-0.69-5.07-2.61-7.37-5.82
c-0.49,0.18-1.01,0.31-1.55,0.39c2.98,4.76,8.62,7.01,8.93,7.12c0.01,0.01,0.03,0,0.04,0c0.23,0.18,0.58,0.12,0.83-0.16
c8.67-9.78,7.7-16.58,6.35-19.76C44.23,10.39,38.98,8.05,35.85,9.3z"/>
					<path class="st2" d="M24.31,27.98h-0.48c0.73,1.53,1.27,3.34,1.6,5.42c0.07,0.42,0.39,0.74,0.73,0.72c0.33-0.03,0.55-0.39,0.49-0.81
c-0.41-2.57-1.11-4.78-2.09-6.62c-0.08-0.06-0.16-0.12-0.23-0.19L24.31,27.98L24.31,27.98z"/>
					<path class="st2" d="M17.38,32.39c-1.09-0.46-2.16-1-3.21-1.62l-0.67-2.68c-0.25,0-0.49-0.01-0.74-0.02l0.18,1.93
c-0.94-0.64-1.85-1.36-2.7-2.17l-0.64-0.08v-0.56c-1.17-1.21-2.22-2.6-3.1-4.21c0.65-0.24,1.75-0.59,3.1-0.87v-1.61
c-2.42,0.46-4.14,1.2-4.3,1.27c-0.01,0.01-0.02,0.02-0.03,0.03c-0.29,0.04-0.5,0.32-0.47,0.7c0.78,13.05,6.28,17.17,9.48,18.46
c4.92,1.99,10.29-0.08,11.62-3.18c0.03-0.08,0.05-0.16,0.06-0.25c0.03-0.3-0.1-0.63-0.34-0.82c-0.31-0.24-0.68-0.14-0.83,0.21
c-0.99,2.31-5.74,4.41-10.27,2.58c-3.25-1.31-7.19-4.93-8.29-14.59c1.65,2.63,3.72,4.68,5.99,6.28l-2.8,1.35l4.29-0.38
c1.1,0.66,2.22,1.22,3.35,1.71l-4.26,2.82l5.87-2.06c0.03-0.01,0.07-0.03,0.11-0.05c0.01-0.01,0.02-0.02,0.03-0.03
c0.77,0.27,1.53,0.51,2.29,0.72l-2.89,2.66l4.54-2.24c5.65,1.29,10.37,0.99,10.77,0.96c0.27-0.02,0.47-0.26,0.5-0.58
c0.01-0.07,0-0.15-0.01-0.23c-0.06-0.42-0.39-0.75-0.72-0.72c-0.1,0.01-4.86,0.31-10.53-1l-2.28-5.8l1.09,5.5
c-0.97-0.26-1.95-0.57-2.94-0.94L17,27.78c-0.11,0.03-0.22,0.06-0.34,0.08L17.38,32.39z"/>
					<path class="st0" d="M17.94,20.06v-0.03c1.26-0.47,1.94-1.46,1.94-2.53c0-0.99-0.48-1.75-1.21-2.19c-0.8-0.55-1.77-0.75-3.35-0.75
c-1.2,0-2.43,0.1-3.11,0.24v11.5c0.54,0.07,1.44,0.16,2.62,0.16c2.14,0,3.51-0.36,4.34-1.09c0.68-0.56,1.13-1.37,1.13-2.41
C20.3,21.34,19.18,20.37,17.94,20.06z M14.33,16.22c0.22-0.05,0.59-0.09,1.21-0.09c1.35,0,2.19,0.5,2.19,1.6
c0,0.99-0.83,1.68-2.31,1.68h-1.09L14.33,16.22L14.33,16.22z M15.46,24.85c-0.49,0-0.85-0.02-1.13-0.05v-3.82h1.06
c1.48,0,2.65,0.56,2.65,1.91C18.04,24.32,16.83,24.85,15.46,24.85z"/>
					<rect x="21.35" y="14.64" class="st2" width="2.14" height="11.7"/>
					<path class="st0" d="M30.01,14.45c-3.3,0-5.55,2.53-5.55,6.13c0,3.44,2.08,5.95,5.38,5.95c3.23,0,5.61-2.24,5.61-6.16
C35.44,17.04,33.43,14.45,30.01,14.45z M29.96,24.81c-2.05,0-3.24-1.89-3.24-4.27c0-2.41,1.13-4.37,3.24-4.37
c2.13,0,3.23,2.08,3.23,4.29C33.18,22.9,32.02,24.81,29.96,24.81z"/>
</svg>

				<p>Экологичность решения</p>
			</div>
			<div class="colIcon ml-5 pl-4">
				<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In  -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="79.51px"
					 height="48.02px" viewBox="0 0 79.51 48.02" style="enable-background:new 0 0 79.51 48.02;" xml:space="preserve">
					<defs>
</defs>
					<path class="st2" d="M25.5,18.81c0-7.03-5.72-12.75-12.75-12.75C5.72,6.06,0,11.78,0,18.81c0,2.06,0.49,4.01,1.36,5.73l11.39,23.48
l11.39-23.48C25.01,22.81,25.5,20.87,25.5,18.81z M12.75,25.86c-3.89,0-7.06-3.17-7.06-7.06c0-3.89,3.17-7.06,7.06-7.06
c3.89,0,7.06,3.17,7.06,7.06S16.64,25.86,12.75,25.86z"/>
					<polygon class="st2" points="33.84,28 32.52,27.98 31.85,29.35 26.18,41.12 17.94,40.94 14.51,48.02 28.2,47.72 30.63,47.67
31.25,45.64 35.42,32.24 58.35,31.84 56.68,28.4 "/>
					<g>
<path class="st0" d="M79.49,26.5l-1.06-15.7c-0.02-0.22-0.2-0.4-0.43-0.4H52.74c-0.22,0-0.41,0.17-0.43,0.4l-1.07,15.77
	c-0.01,0.12,0.03,0.23,0.11,0.32c0.08,0.09,0.19,0.14,0.31,0.14h13.5v2l-6.13,1.28c-0.2,0.04-0.35,0.23-0.34,0.43
	c0.01,0.21,0.16,0.38,0.37,0.41L65.6,32c0.01,0,0.02,0.01,0.03,0.01c0.01,0,0.01,0,0.02,0c0.01,0,0.01,0,0.02,0
	C65.68,32,65.69,32,65.7,32l6.53-0.85c0.21-0.03,0.36-0.2,0.37-0.41c0.01-0.21-0.14-0.39-0.34-0.43L66.02,29v-1.98h13.05
	c0,0,0,0,0.01,0c0.24,0,0.43-0.19,0.43-0.43C79.51,26.56,79.5,26.53,79.49,26.5z M73.72,22.96l-0.59-0.5l-0.06-1.59l0.59-0.54h4.56
	l0.18,2.63H73.72z M52.34,22.96l0.18-2.63h5.27l0.56,0.52l-0.07,1.65l-0.54,0.47H52.34z M58.11,13.98l0.51,0.47l-0.07,1.79
	l-0.58,0.54h-5.2l0.19-2.79L58.11,13.98L58.11,13.98z M77.79,13.98l0.19,2.79h-4.47l-0.63-0.57l-0.07-1.72l0.54-0.49L77.79,13.98
	L77.79,13.98z M73.6,19.9l-0.59-0.51l-0.07-1.69l0.54-0.5h4.52l0.18,2.7L73.6,19.9L73.6,19.9z M66.42,22.96l-0.54-0.52v-1.56
	l0.63-0.54h5.63l0.5,0.46l0.07,1.71l-0.47,0.46L66.42,22.96L66.42,22.96z M59.22,22.96l-0.5-0.49l0.07-1.65l0.54-0.5h5.64
	l0.49,0.48v1.72l-0.5,0.43L59.22,22.96L59.22,22.96z M52.55,19.9l0.18-2.7h5.24l0.52,0.48l-0.07,1.75l-0.55,0.47H52.55z
	 M64.92,13.98l0.54,0.47v1.79l-0.58,0.53h-5.41l-0.5-0.52l0.07-1.81l0.52-0.46L64.92,13.98L64.92,13.98z M71.9,13.98l0.48,0.42
	l0.08,1.88l-0.47,0.49h-5.59l-0.51-0.53v-1.81l0.48-0.45L71.9,13.98L71.9,13.98z M66.47,19.9l-0.58-0.52V17.6l0.46-0.4h5.71
	l0.46,0.4l0.08,1.85l-0.43,0.45L66.47,19.9L66.47,19.9z M59.3,19.9l-0.46-0.48l0.07-1.79l0.51-0.44h5.47l0.57,0.52v1.73l-0.51,0.45
	L59.3,19.9L59.3,19.9z M72.33,13.05l-0.48,0.5h-5.46l-0.5-0.52v-1.78h6.37L72.33,13.05z M65.46,13.03l-0.58,0.53h-5.27l-0.51-0.53
	l0.07-1.77h6.28V13.03z M58.66,23.9l0.55-0.51h5.71l0.54,0.53v2.25h-6.89L58.66,23.9z M65.89,26.17v-2.28l0.53-0.49h5.85l0.51,0.47
	l0.09,2.31H65.89z M77.76,13.55h-4.4L72.75,13l-0.07-1.74h4.92L77.76,13.55z M58.75,11.26l-0.07,1.78l-0.57,0.52h-5.13l0.16-2.3
	H58.75z M52.32,23.39h5.4l0.52,0.51l-0.09,2.27h-6.01L52.32,23.39z M65.17,29.9v1.18l-3.49-0.46L65.17,29.9z M66.02,31.09v-1.22
	l3.6,0.75L66.02,31.09z M73.29,26.17l-0.09-2.24l0.55-0.54h4.69l0.19,2.78L73.29,26.17L73.29,26.17z M66.07,1.8
	c-1.58,0-2.86,1.28-2.86,2.86s1.28,2.86,2.86,2.86c1.58,0,2.86-1.28,2.86-2.86S67.65,1.8,66.07,1.8z M66.07,6.98
	c-1.28,0-2.32-1.04-2.32-2.32s1.04-2.32,2.32-2.32c1.28,0,2.32,1.04,2.32,2.32S67.35,6.98,66.07,6.98z M61.66,3.26
	c0-0.02,0-0.04,0.01-0.05c0.02-0.07,0.1-0.11,0.17-0.09l0.73,0.24c0.07,0.02,0.11,0.1,0.09,0.17c-0.02,0.06-0.07,0.09-0.13,0.09
	c0,0,0,0,0,0l0,0c-0.01,0-0.03,0-0.04-0.01l-0.73-0.24C61.7,3.36,61.67,3.31,61.66,3.26z M63.31,1.08
	c-0.04-0.06-0.03-0.14,0.03-0.19l0,0l0,0c0.06-0.04,0.14-0.03,0.19,0.03l0.45,0.62c0.04,0.06,0.03,0.14-0.03,0.19
	c-0.02,0.02-0.05,0.03-0.08,0.03c-0.04,0-0.08-0.02-0.11-0.06l0,0l0,0L63.31,1.08z M68.17,1.72c-0.06-0.04-0.07-0.13-0.03-0.19
	l0.45-0.62c0.04-0.06,0.13-0.07,0.19-0.03c0.06,0.04,0.07,0.13,0.03,0.19l-0.45,0.62c-0.03,0.04-0.07,0.06-0.11,0.06
	C68.23,1.74,68.2,1.74,68.17,1.72z M69.48,3.51c-0.02-0.07,0.02-0.15,0.09-0.17L70.3,3.1c0.07-0.02,0.15,0.02,0.17,0.09
	c0.02,0.07-0.02,0.15-0.09,0.17l-0.73,0.24c-0.01,0-0.03,0.01-0.04,0.01C69.55,3.6,69.5,3.57,69.48,3.51z M70.48,6.05
	c-0.02,0.06-0.07,0.09-0.13,0.09c-0.01,0-0.03,0-0.04-0.01L69.58,5.9c-0.07-0.02-0.11-0.1-0.09-0.17c0.02-0.07,0.1-0.11,0.17-0.09
	l0.73,0.24C70.46,5.9,70.5,5.98,70.48,6.05z M68.83,8.18c0.04,0.06,0.03,0.14-0.03,0.19c-0.02,0.02-0.05,0.03-0.08,0.03
	c-0.04,0-0.08-0.02-0.11-0.06l-0.45-0.62c-0.04-0.06-0.03-0.14,0.03-0.19c0.06-0.04,0.14-0.03,0.19,0.03L68.83,8.18z M65.95,9.12
	V8.35c0-0.07,0.06-0.13,0.13-0.13c0.02,0,0.04,0,0.05,0.01c0.05,0.02,0.08,0.07,0.08,0.12v0.77c0,0.07-0.06,0.13-0.13,0.13
	C66.01,9.26,65.95,9.2,65.95,9.12z M63.31,8.29c0-0.02,0-0.03,0-0.05c0-0.02,0.01-0.03,0.02-0.05l0.45-0.62
	c0.04-0.06,0.13-0.07,0.19-0.03c0.03,0.02,0.05,0.05,0.05,0.09c0.01,0.03,0,0.07-0.02,0.1l-0.45,0.62
	c-0.03,0.04-0.07,0.05-0.11,0.05c-0.03,0-0.05-0.01-0.08-0.03C63.33,8.36,63.31,8.32,63.31,8.29z M62.66,5.75
	c0.02,0.07-0.02,0.15-0.09,0.17l0,0v0l-0.73,0.24c-0.01,0-0.03,0.01-0.04,0.01c-0.06,0-0.11-0.04-0.13-0.09
	c-0.01-0.02-0.01-0.04-0.01-0.05c0-0.05,0.04-0.1,0.09-0.12l0.73-0.24C62.56,5.64,62.64,5.68,62.66,5.75z M65.93,0.9V0.13
	c0-0.07,0.06-0.13,0.13-0.13l0,0l0,0c0.07,0,0.13,0.06,0.13,0.13v0.77c0,0.07-0.06,0.13-0.13,0.13C65.99,1.04,65.93,0.98,65.93,0.9
	L65.93,0.9z"/>
</g>
</svg>
				<p>Энергоснабжение
					изолированных
					территорий</p>

			</div>
	</div>
</template>

<script>
    export default {
        name: "SolarCan"
    }
</script>

<style scoped>
	.solarContainer{
		display: flex;
		flex-wrap: wrap;
	}

	.st0{fill:#8CC63F;}
	.st1{fill:#FFFFFF;}
	.st2{opacity:0.8;fill:#4D4D4D;}


	.colIcon{
		display: flex;
		flex-direction: row;
		place-content: center;
		padding-top: 30px;
		max-width: 300px;
	}

	.colIcon > svg{
		min-width: 70px;
		margin-right: 10px;
		margin-right: 10px;
	}

	.colIcon > p{
		color: #5f5f5f;
		font-size: 14px;
		margin: 0;
		display: flex;
		align-items: center;
	}
</style>